import { Injectable, isDevMode } from '@angular/core';
import { Addresses } from '../city.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { Client } from '@app/shared';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Injectable()
export class AddressService {
  cities: Addresses[] = [];
  getAddres = new Subject<Addresses[]>();
  city;

  constructor(private http: HttpClient, private client: Client) {}

  setAddresses(query: string, lang: string, isIntercity: boolean, userId, addressType?) {
    if (this.city.use_native_search || isIntercity) {
      let params = new HttpParams({
        fromObject: {
          city: isIntercity ? 'intercity' : this.city.key,
          lang: lang,
          query: query,
          user_id: 'P' + userId
        }
      });
      console.log(addressType);

      if (addressType !== 'all') {
        params = params.append('address_type', addressType);
      }

      this.http.get(environment.config.addresses, { params: params }).subscribe(data => {
        this.cities = data['data'].map(item => {
          return {
            name: isIntercity ? 'мг ' + item.display_name : item.display_name,
            lat: item.location.latitude,
            lng: item.location.longitude,
            relation_id: item.address_id,
            is_user_address: item.is_user_address,
            id: null,
            idForDeleting: item.id,
            address_id: null,
            intercity: item.city_key == 'intercity'
          };
        });
        this.getAddres.next(this.cities);
      });
    } else {
      this.http.get(`operator/address/search/${this.city.id}?lang=${lang}&query=` + query).subscribe(data => {
        // this.http.get(`http://dev-miranda.megakit.pro:9800/search${isIntercity? '?city=intercity&':'/'+this.city.id+'?'}lang=${lang}&query=` + query).subscribe(data => {
        this.cities = data['data'].map(item => {
          let name = '';
          // let name_old = '';
          let street = '';
          let street_name = '';
          let house = '';
          let place = '';
          let place_name = '';
          let area = '';

          for (let i = 0; i < item.components.length; i++) {
            let obj = item.components[i];
            if (obj.type == 'address_type') {
            } else if (obj.type == 'place' || obj.type == 'place_name') {
              if (obj.type == 'place') {
                place += obj.name;
              } else {
                place_name += obj.name;
              }
            } else if (obj.type == 'address_name') {
              name += obj.name + ' ';
            } else if (obj.type == 'street_name' || obj.type == 'street') {
              if (!!name && obj.type == 'street_name') {
                street_name += obj.name;
              } else if (!name) {
                obj.type == 'street' ? (street += obj.name) : (street_name += obj.name);
              }
            } else if (obj.type == 'area') {
              area = ' (' + obj.name + '), ';
            } else if (obj.type == 'house_type' || obj.type == 'house_name') {
              house += obj.name + ' ';
            }
          }
          name += street_name + ' ' + street + area + ' ' + house;
          if (place) {
            name += place_name + ' (' + place + ')';
          }
          return {
            name: name,
            lat: item.location.coordinates[1],
            lng: item.location.coordinates[0],
            id: item.id
          };
        });
        this.getAddres.next(this.cities);
      });
    }
  }

  removePassAddress(passenger_id: string, address_id: string): Observable<any> {
    return this.http
      .delete(this.client.deletePassengerAddress(), { params: { passenger_id, address_id } })
      .pipe(mergeMap(() => of(true)));
  }

  completeOrder(orderId: string) {
    const body = { id: orderId };
    return this.http.post(this.client.getTripCompleteUrl(), body);
  }

  unassignOrder(body) {
    return this.http.post(this.client.getTripCancelUrl(), body);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/address.service.ts